import React from 'react';
import { motion } from 'framer-motion';

// Real results from experiment logs
const REAL_COMPARISON = [
  { id: 'gat',        name: 'GAT',        acc: 81.5, f1: 80.9, time: 52,  params: '~2.1M', isBest: true  },
  { id: 'gcn',        name: 'GCN',        acc: 79.7, f1: 79.1, time: 10,  params: '~740K', isBest: false },
  { id: 'graphsage',  name: 'GraphSAGE',  acc: 76.8, f1: 76.2, time: 39,  params: '~750K', isBest: false },
  { id: 'mlp',        name: 'MLP',        acc: 42.8, f1: 41.5, time: 3,   params: '~720K', isBest: false },
];

export const ModelComparisonTable: React.FC = () => {
  return (
    <div className="comparison-table-container glass-card overflow-hidden">
      <h3 className="mb-4 px-2">
        <span className="section-icon text-accent-blue">🏆</span>
        Model Leaderboard
      </h3>
      
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-border-subtle bg-bg-glass">
              <th className="py-3 px-4 font-semibold text-text-secondary text-sm">Model</th>
              <th className="py-3 px-4 font-semibold text-text-secondary text-sm">Accuracy</th>
              <th className="py-3 px-4 font-semibold text-text-secondary text-sm">F1-Score</th>
              <th className="py-3 px-4 font-semibold text-text-secondary text-sm">Inference</th>
              <th className="py-3 px-4 font-semibold text-text-secondary text-sm">Parameters</th>
            </tr>
          </thead>
          <tbody>
            {REAL_COMPARISON.sort((a, b) => b.acc - a.acc).map((model, idx) => (
              <motion.tr 
                key={model.id}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                className={`border-b border-border-subtle hover:bg-bg-glass-hover transition-colors ${model.isBest ? 'bg-[rgba(0,251,251,0.05)]' : ''}`}
              >
                <td className="py-3 px-4">
                  <div className="flex items-center gap-2">
                    {model.isBest && <span className="text-accent-amber text-lg">👑</span>}
                    <span className="font-semibold text-text-primary">{model.name}</span>
                  </div>
                </td>
                <td className="py-3 px-4">
                  <div className="flex items-center gap-2">
                    <span className={`font-mono font-bold ${model.isBest ? 'text-success' : 'text-text-primary'}`}>
                      {model.acc}%
                    </span>
                    {model.isBest && (
                      <div className="h-1.5 w-16 bg-[rgba(255,255,255,0.1)] rounded-full overflow-hidden">
                        <div className="h-full bg-success w-[83%]" />
                      </div>
                    )}
                  </div>
                </td>
                <td className="py-3 px-4 font-mono text-text-secondary">{model.f1}%</td>
                <td className="py-3 px-4 font-mono">
                  <span className={`${model.time < 10 ? 'text-accent-cyan' : 'text-text-muted'}`}>
                    {model.time}ms
                  </span>
                </td>
                <td className="py-3 px-4 font-mono text-text-muted">{model.params}</td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
